import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { EventListItem, IEventListItem } from "./eventListItem";

export interface IEventListItems extends ListItems<IEventListItem> {
}

export class EventListItems extends ListItems<EventListItem> implements IEventListItems {
    constructor();
    constructor(obj: IEventListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, EventListItem);
    }
}